import React from "react";
var __jsx = React.createElement;
// src/components/SearchComponent/SEOInternalLinks/SEOInternalLinks.tsx
import { useTranslation } from "@i18n";
import MakeModelYearTags from "../UnbxdComponents/MakeModelYearTags/MakeModelYearTags";
import { useParams } from "react-router-dom";
import { processSEOLinksData, createSectionMetadata } from "./SEOInternalLinksUtils";

// Component props type

var SEOInternalLinks = function SEOInternalLinks(_ref) {
  var _ref$selectedOptions = _ref.selectedOptions,
    selectedOptions = _ref$selectedOptions === void 0 ? [] : _ref$selectedOptions,
    _ref$metaData = _ref.metaData,
    metaData = _ref$metaData === void 0 ? {} : _ref$metaData,
    _ref$filters = _ref.filters,
    filters = _ref$filters === void 0 ? [] : _ref$filters;
  var routeParams = useParams();
  var make = routeParams.make,
    model = routeParams.model; // Extract make and model from routeParams
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _processSEOLinksData = processSEOLinksData(selectedOptions, filters, routeParams),
    pageType = _processSEOLinksData.pageType,
    filteredMakes = _processSEOLinksData.filteredMakes,
    filteredModels = _processSEOLinksData.filteredModels,
    years = _processSEOLinksData.years,
    selectedOptionsExcludingMakes = _processSEOLinksData.selectedOptionsExcludingMakes,
    selectedOptionsExcludingModels = _processSEOLinksData.selectedOptionsExcludingModels;

  // Create metadata objects for different sections
  // Create metadata objects using the utility function
  var yearsSectionMetadata = createSectionMetadata(filteredMakes, filteredModels, years);
  var modelsSectionMetadata = createSectionMetadata(filteredMakes, filteredModels);
  var makesSectionMetadata = createSectionMetadata(filteredMakes);
  return (
    // border radius 3% tailwind
    make && /*#__PURE__*/React.createElement("div", {
      id: "posts-seo-internal-links",
      className: "pb-8"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rounded-lg overflow-hidden border border-solid border-neutral-10"
    }, pageType === 'year' && /*#__PURE__*/React.createElement(MakeModelYearTags, {
      selectedOptions: selectedOptions,
      metaData: yearsSectionMetadata,
      title: t("browse_years", {
        ns: "web_search"
      }),
      baseUrl: "/autos/".concat(make === null || make === void 0 ? void 0 : make.slugify(), "/").concat(model === null || model === void 0 ? void 0 : model.slugify())
    }), (pageType === 'model' || pageType === 'year') && /*#__PURE__*/React.createElement(MakeModelYearTags, {
      selectedOptions: selectedOptionsExcludingModels,
      metaData: modelsSectionMetadata,
      title: t("models", {
        ns: "web_search"
      }),
      baseUrl: "/autos/".concat(make === null || make === void 0 ? void 0 : make.slugify())
    }), (pageType === 'make' || pageType === 'model' || pageType === 'year') && /*#__PURE__*/React.createElement(MakeModelYearTags, {
      selectedOptions: selectedOptionsExcludingMakes,
      metaData: makesSectionMetadata,
      title: t("brands", {
        ns: "web_search"
      }),
      baseUrl: "/autos"
    })))
  );
};
export default SEOInternalLinks;